/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const IncomingCallIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
    onClick={props.onClick}
  >
    <g strokeWidth="2.5">
      <path d="M29.972 40.048a8.01 8.01 0 0 0 0-11.316l-8.488-8.484c-3.12-3.12-8.188-3.12-11.312 0l-4.656 4.656A11.98 11.98 0 0 0 4 40c13.524 20.44 31.564 38.476 52 52 4.756 3.14 11.076 2.516 15.1-1.516l4.656-4.656c3.124-3.12 3.124-8.188 0-11.312l-8.488-8.484c-3.12-3.124-8.188-3.124-11.312 0l-2.828 2.828c-9.304-7.624-18.364-16.68-25.988-25.984l2.832-2.828zM54 42L94 2M80.008 41.996h-26v-26" />
    </g>
  </svg>
);

export default IncomingCallIcon;
